'use strict';exports.__esModule = true;var _superagent = require('superagent');var _superagent2 = _interopRequireDefault(_superagent);
var _config = require('../config');var _config2 = _interopRequireDefault(_config);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    return _config2.default.targetApi + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return '/api' + adjustedPath;
}

/* eslint-disable no-return-assign */var
ApiClient =
function ApiClient(req) {var _this = this;_classCallCheck(this, ApiClient);this.
























  empty = function () {return undefined;};methods.forEach(function (method) {return _this[method] = function (path) {var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},params = _ref.params,data = _ref.data;return new Promise(function (resolve, reject) {var request = _superagent2.default[method](formatUrl(path));if (params) {request.query(params);}if (__SERVER__) {var cookie = req.get('cookie');if (cookie) {request.set('cookie', cookie);}}if (data) {request.send(data);}request.end(function (err) {var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},body = _ref2.body;return err ? reject(body || err) : resolve(body);});});};});} // To avoid exporting empty class
;
/* eslint-disable no-return-assign */exports.default = ApiClient;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 3084
// module chunks = 0